import { parse } from 'qs';
import { useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import {
    upgradeSubscriptionEnabled,
    upgradeSubscriptionWebviewEnabled,
} from 'reactApp/appHelpers/featuresHelpers/features/upgradeSubscription';
import { checkMobileWebviewPayAvailable } from 'reactApp/modules/billing/billing.helpers';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { authPopup } from 'reactApp/modules/ph/ph.thunkActions';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { upgradeSubscriptionPlanRequest } from 'reactApp/modules/upgradeSubscription/upgradeSubscription.module';
import { UpgradeSubscriptionSelectors } from 'reactApp/modules/upgradeSubscription/upgradeSubscription.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import type { RootState } from 'reactApp/store';
import { openTariffBuyDialog } from 'reactApp/ui/TariffBuy/TariffBuy.helpers';

export const useUpgradeFromQuery = () => {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const queryParams = parse(search, { ignoreQueryPrefix: true });
    const { productId, action } = queryParams;
    const isFromUpgrade =
        (IS_WEBVIEW ? upgradeSubscriptionWebviewEnabled : upgradeSubscriptionEnabled) && productId && action === 'upgrade';
    const email = useSelector(UserSelectors.getEmail);
    const isPhone = EnvironmentSelectors.isMobile();
    const isMobile = isPhone || IS_WEBVIEW;
    const isMobilePayAvailable = checkMobileWebviewPayAvailable();

    useLayoutEffect(() => {
        if (isFromUpgrade && !email) {
            dispatch(
                authPopup({
                    closable: false,
                    loginRequest: true,
                    successPage: `${window.location.href}`,
                })
            );
        }
    }, [isFromUpgrade, email]);

    const subscriptions = useSelector(BillingDataSelectors.sortSubscriptionsBySpace);
    const subId = subscriptions[0]?.id;

    const { upgradeSet } = useSelector(UpgradeSubscriptionSelectors.getUpgradeState);
    const price = upgradeSet.data?.cost;
    const product = useSelector((state: RootState) => ProductsSelectors.getProductById(state, productId));
    const space = product?.space.value;

    useEffect(() => {
        if (isFromUpgrade && subId && productId) {
            dispatch(
                upgradeSubscriptionPlanRequest({
                    sub_id: subId,
                    product_id: productId,
                    isMobile,
                    isMobilePayAvailable,
                })
            );
        }
    }, [isFromUpgrade, subId, productId]);

    useEffect(() => {
        if (isFromUpgrade && subId && productId && upgradeSet.isLoaded) {
            openTariffBuyDialog({
                isMobile,
                onClose: () => {},
                id: productId,
                paySource: 'mnz_upgrade_subscription',
                enabledMidasPayment: true,
                title: `Подписка Mail Space: ${space} за\u00A0${price}\u00A0₽`,
                linkForUpgrade: upgradeSet.data?.pw || '',
            });
        }
    }, [upgradeSet.isLoaded]);
};
